module.exports = __webpack_public_path__ + "img/ring_MARTEC_MFA.e1fc2a04.png";